export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-male-symbol-1262ee0278636129eeeff08908cd8694.svg";